var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"dark":""}},[_c('v-card-text',{staticClass:"py-5"},[_c('h1',{staticClass:"display-2"},[_vm._v("Modulo de Adquisiciones")]),_c('p',{staticClass:"subheading ma-0"},[_vm._v("Abastecimiento, compras y proveedores")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }